let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e7bar")).then(() => parcelRequire('jWUzL'));